import { useDispatch, useSelector } from "react-redux";
import { GridActionsCellItem } from "@mui/x-data-grid";
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { policies as permessi } from "../../const/policies"
import { useNavigate } from 'react-router-dom';
import { multiDialogAction } from '../../const/Dialog/MultiDialogAction';
import { faBan, faLocationDot, faPen, faTrash, faRotateRight, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from "react-i18next";
import useMobileDetection from "../../Hooks/useMobileDetection";
import { Typography, Menu, Box, IconButton, Divider, ListItem, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { handleDialogEditBuilding, handleDialogToEnableDisableBuilding } from "./operations/handleDialogEditBuilding";
import { dialogPageTypes } from "../../const/dialogPageTypes";
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { setScrollY } from "../../redux/reducers/scroll-reducer";


const ButtonBoxBuilding = ({ row: rowInfo, rowInfoId }) => {
  const state = useSelector((state) => state.userDate);
  const { policies, responsabileEdificio } = state;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const idEdificio = rowInfoId;
  const isMobile = useMobileDetection(600);
  const viewState = useSelector((state) => state.viewState);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    dispatch(setScrollY(document.querySelector("main.MuiBox-root").scrollTop));
  };
  const actionButtonStyle = {
    border: "1px solid #dcdcdc",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#eae5e591",
    cursor: "pointer",
    minWidth: "78px",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#3e6bb4",
    },
  };



  return (
    <>
      {!isMobile && !viewState ? (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
            <Tooltip title={t("actions")}>
              <IconButton
                onClick={handleMenuClick}
                size="small"
                sx={{
                  mr: 2,
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                }}
                aria-controls={menuOpen ? 'actions-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={menuOpen ? 'true' : undefined}
              >
                <FontAwesomeIcon icon={faEllipsisV} size="lg" />
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            anchorEl={menuAnchorEl}
            id="actions-menu"
            open={menuOpen}
            onClose={handleMenuClose}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            slotProps={{
              paper: {
                elevation: 2,
                sx: {
                  mt: 1,
                  borderRadius: "10px",
                  minWidth: 180,
                },
              },
            }}
          >
            {policies.indexOf(permessi.edificiInserimentoModifica) !== -1 && (
              <MenuItem
                onClick={() =>
                  handleDialogEditBuilding(
                    { type: multiDialogAction.edit, row: rowInfo },
                    dispatch
                  )
                }
              >
                <ListItemIcon>
                  <FontAwesomeIcon icon={faPen} />
                </ListItemIcon>
                <ListItemText>{t("edit")}</ListItemText>
              </MenuItem>
            )}

            {policies.indexOf(permessi.edificiEliminazioneRipristino) !== -1 && (
              <MenuItem
                onClick={(event) =>
                  handleDialogEditBuilding(
                    { type: multiDialogAction.delete, row: rowInfo },
                    dispatch,
                    event
                  )
                }
              >
                <ListItemIcon>
                  {rowInfo.dispositivoAbilitato ? (
                    <FontAwesomeIcon icon={faBan} />
                  ) : (
                    <FontAwesomeIcon icon={faTrash} />
                  )}
                </ListItemIcon>
                <ListItemText>
                  {rowInfo.dispositivoAbilitato ? t("enable") : t("delete")}
                </ListItemText>
              </MenuItem>
            )}

            <Divider />

            {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
              responsabileEdificio.length > 0) && (
                <MenuItem
                  onClick={(event) =>
                    handleDialogToEnableDisableBuilding(
                      {
                        type: multiDialogAction.disable,
                        dialogPageType: dialogPageTypes.building,
                        row: rowInfo,
                      },
                      dispatch,
                      event
                    )
                  }
                >
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faBan} />
                  </ListItemIcon>
                  <ListItemText>{t("disable_v3")}</ListItemText>
                </MenuItem>
              )}

            {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
              responsabileEdificio.length > 0) && (
                <MenuItem
                  onClick={(event) =>
                    handleDialogToEnableDisableBuilding(
                      {
                        type: multiDialogAction.enable,
                        dialogPageType: dialogPageTypes.building,
                        row: rowInfo,
                      },
                      dispatch,
                      event
                    )
                  }
                >
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faRotateRight} />
                  </ListItemIcon>
                  <ListItemText>{t("restore_v2")}</ListItemText>
                </MenuItem>
              )}

            <Divider />

            {policies.indexOf(permessi.zoneVisualizzazione) !== -1 && (
              <MenuItem onClick={() => navigate("" + idEdificio)}>
                <ListItemIcon>
                  <FontAwesomeIcon icon={faArrowRight} />
                </ListItemIcon>
                <ListItemText>{t("zone")}</ListItemText>
              </MenuItem>
            )}
          </Menu>
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", pl: 0 }}>
            {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
              responsabileEdificio.length > 0) && (
                <GridActionsCellItem
                  sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                  className={isMobile || viewState ? "forceNoPaddingLeft" : ""}
                  icon={
                    <Tooltip title={t("disable_v3")}>
                      <div style={actionButtonStyle}>                      <>
                        <FontAwesomeIcon icon={faBan} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                        <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("disable_v3")}</Typography>
                      </>
                      </div>
                    </Tooltip>
                  }
                  label={t("disable_v3")}
                  onClick={(event) =>
                    handleDialogToEnableDisableBuilding({ type: multiDialogAction.disable, dialogPageType: dialogPageTypes.building, row: rowInfo }, dispatch, event)
                  }
                />
              )}

            {(policies.indexOf(permessi.edificiAbilitaDisabilita) !== -1 ||
              responsabileEdificio.length > 0) && (
                <GridActionsCellItem
                  className={isMobile || viewState ? "forceNoPaddingLeft" : ""}
                  sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                  icon={
                    <Tooltip title={t("restore_v2")}>
                      <div style={actionButtonStyle}>
                        <FontAwesomeIcon icon={faRotateRight} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                        <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("restore_v2")}</Typography>
                      </div>
                    </Tooltip>
                  }
                  label={t("restore_v2")}
                  onClick={(event) =>
                    handleDialogToEnableDisableBuilding({ type: multiDialogAction.enable, dialogPageType: dialogPageTypes.building, row: rowInfo }, dispatch, event)
                  }
                />
              )}

            {policies.indexOf(permessi.edificiEliminazioneRipristino) !== -1 &&
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile ? "button-Button Box-Mobile forceNoPaddingLeft" : ""}
                icon={
                  <Tooltip title={rowInfo.dispositivoAbilitato ? t("enable") : t("delete_v3")}>
                    <div style={actionButtonStyle}>
                      <FontAwesomeIcon
                        icon={faTrash}
                        style={{ fontSize: "12px", }}
                      />
                      <Typography
                        sx={{ fontSize: 11, fontWeight: 500 }}
                      >
                        {t("delete_v3")}
                      </Typography>
                    </div>
                  </Tooltip>
                }
                label={t("delete")}
                onClick={(event) =>
                  handleDialogEditBuilding(
                    { type: multiDialogAction.delete, row: rowInfo },
                    dispatch,
                    event
                  )
                }
              />}
          </Box>
        </>
      )}
    </>
  );

};

export default ButtonBoxBuilding;
